import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Col, Paper, Row, Spin } from 'redpoints-front-components/index';

import { getTestPurchaseDomainsIsLoaded } from '../../../reducers/tasks/testPurchase';
import TestPurchaseFilterBy from './TestPurchaseFilterBy';
import TestPurchaseFiltersActions from './TestPurchaseFiltersActions';
import TestPurchaseFiltersDomains from './TestPurchaseFiltersDomains';

const TestPurchaseFilters = ({
  hasFiltersApplied,
  isEnableFilterByTenant,
  isLoadedDomains,
}) => (
  <Spin spinning={!isLoadedDomains}>
    <Paper>
      <Row gutter={16}>
        <Col xl={10} md={12}>
          <TestPurchaseFilterBy
            isEnableFilterByTenant={isEnableFilterByTenant}
          />
        </Col>
        <Col xl={9} md={12}>
          <TestPurchaseFiltersDomains />
        </Col>
        <Col xl={5} md={12} align="right">
          <TestPurchaseFiltersActions hasFiltersApplied={hasFiltersApplied} />
        </Col>
      </Row>
    </Paper>
  </Spin>
);

const mapStateToProps = state => ({
  isLoadedDomains: getTestPurchaseDomainsIsLoaded(state),
});

export default compose(connect(mapStateToProps), memo)(TestPurchaseFilters);
